import './Avatar.css';


const Avatar = (
    {
        email,
        className = "",
        size='lg',
        avatarStyle = {}
    }

    ) => {

    const userFirstLetter = email?.charAt(0)?.toUpperCase();

    const avatarClass = () => {
        switch(size){
            case 'lg':
                return 'avatar-large';
            case 'md':
                return 'avatar-medium';
            case 'sm':
                return 'avatar-small';
            default:
                return 'avatar-large';
        }
    };

    return (
        <div className={`avatar avatar-container`}>
            {/* Header */}
            <div className={`avatar user-avatar ${avatarClass()} ${className}`} style={{...avatarStyle}}>{userFirstLetter}</div> 
        </div>
    );
};

export default Avatar;